import { render } from "./willkommen.vue?vue&type=template&id=0e9f0c5a&scoped=true"
import script from "./willkommen.vue?vue&type=script&lang=js"
export * from "./willkommen.vue?vue&type=script&lang=js"

import "./willkommen.vue?vue&type=style&index=0&id=0e9f0c5a&lang=less&scoped=true"

import exportComponent from "/home/bula/demo/bula2023/vue/bula2023/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9f0c5a"]])

export default __exports__